import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

// clipboard
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
